import React from 'react';
import ReactDOM from 'react-dom';
import { Image } from '@wearesection/raise-ui/atoms';

function ReactRenderImageBlock() {
	const raiseImageBlocks = Array.from( document.querySelectorAll( '.raise-image' ) ) as HTMLElement[];
	raiseImageBlocks?.length > 0 &&
		raiseImageBlocks.forEach( ( element: HTMLElement ) => {
			const imageWidth = element?.firstElementChild?.getAttribute( 'width' ) as string;
			const imageHeight = element?.firstElementChild?.getAttribute( 'height' ) as string;
			const imageSrc = element?.firstElementChild?.getAttribute( 'src' ) as string;
			const imageSrcSet = element?.firstElementChild?.getAttribute( 'srcSet' ) as string;
			const imageSizes = element?.firstElementChild?.getAttribute( 'sizes' ) as string;
			const imageAlt = element?.firstElementChild?.getAttribute( 'alt' ) as string;
			ReactDOM.render(
				<Image
					width={ imageWidth }
					decoding="async"
					height={ imageHeight }
					src={ imageSrc }
					srcSet={ imageSrcSet }
					alt={ imageAlt }
					sizes={ imageSizes }
				/>,
				element,
			);
		} );
}

export default ReactRenderImageBlock;
